module.exports = __webpack_public_path__ + "static/media/Livre4.e5e84202.png";